import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import _mapValues from 'lodash/mapValues'
import _values from 'lodash/values'
import { subscriptionPlans } from 'config'


class SubscriptionSelector extends PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    customerId: PropTypes.string,
    planId: PropTypes.string,
    nextPlanId: PropTypes.string,
    nextBillingDate: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
  };

  constructor(...args) {
    super(...args);

    this.state = { plan: this.props.nextPlanId };

  }

  submitHandler = (e) => {
    e.preventDefault();
    this.props.onSubmit(this.state.plan)
  };

  inputChangeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  };

  renderPlanOption = (planInfo, key) => {
    const { plan } = this.state;
    const { nextPlanId : currentPlan } = this.props;

    return (<div key={ key } className="form-check">
      <label className="form-check-label">
        <input
          type="radio"
          className="form-check-input"
          name="plan"
          value={ key }
          checked={ plan === key }
          onChange={ this.inputChangeHandler }
        />
        { planInfo.title } ({ planInfo.price ? `$${planInfo.price}/month` : 'free' })
        <span className="form-check__sub text-muted small ml-0 ml-sm-1">{ planInfo.limit } pages / month</span>
        { currentPlan === key && <span className="badge badge-info ml-2">your plan</span>}
      </label>
    </div>)
  };

  render() {
    const { nextPlanId } = this.props;
    const { plan } = this.state;

    return (<div>
        <fieldset className="form-group">
          { _values(_mapValues(subscriptionPlans, this.renderPlanOption)) }
        </fieldset>
        <button type="button"
                className="btn btn-primary"
                disabled={nextPlanId === plan}
                onClick={ this.submitHandler }>
          Proceed
        </button>
        <button type="button"
                className="btn b12tn-secondary ml-2"
                onClick={this.props.onCancel}>
          Cancel
        </button>
    </div>)
  }
}


export default SubscriptionSelector



// WEBPACK FOOTER //
// ./src/components/account/subscription/subscription-selector.js